<template>
    <div>
        <page-header>
            <template #breadcrumbs>
                <router-link to="/analytics">Аналитика</router-link> &raquo; Отчеты по заданным параметрам
            </template>
            <h2>Отчеты по заданным параметрам</h2>
        </page-header>
        <div>
            <ul class="nav nav-tabs nav-justified">
                <li class="nav-item" v-if="accessRights.patientRegistry">
                    <a class="nav-link" @click.prevent="setActive('tab1')" :class="{ active: isActive('tab1') }" href="#tab1">Отчет по Регистру ЛРАС</a>
                </li>
                <li class="nav-item" v-if="accessRights.groupOfRisk">
                    <a class="nav-link" @click.prevent="setActive('tab2')" :class="{ active: isActive('tab2') }" href="#tab2">Отчет по группе Риска</a>
                </li>
            </ul>
        </div>

        <div class="tab-content mt-4" id="myTabContent">
            <div class="tab-pane fade" v-if="accessRights.patientRegistry" :class="{ 'active show': isActive('tab1') }" id="tab1">
                <section class="content">
                    <report-with-params-ras-filter
                            v-bind:filters="filterRas"
                            v-on:apply="onFiltersApply($event)"
                            v-on:reset="onFiltersReset($event)"
                            v-on:exportReport="exportReportRas($event)"
                    />
                    <template v-if="!isLoading">
                    <div class="table-inner mb-4" v-if="reportRas">
                        <table class="table-custom">
                            <thead>
                            <tr>
                                <th v-for="(hdr, index) in reportRas.header" :key="index">{{hdr.title}}
                                  <i style="cursor: pointer" @click="columnSort(index, 'tab1')"  class="ml-2 fas text-gray fa-sort-amount-down-alt" :class="{'fas text-black fa-sort-amount-up': sortMode && index === idx, 'text-black': index === idx}"></i></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(item, i) in reportRas.data" :key="i">
                                <td v-for="(hdr, index) in reportRas.header" :key="index">
                                    {{item.values[index]}}
                                </td>
                            </tr>
                            </tbody>
                            <tfoot>
                            <tr>
                                <td v-for="(val, i) in reportRas.summary[0].values" :key="i">
                                    {{val}}
                                </td>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                    </template>
                    <template v-else>
                      <div>Загрузка...</div>
                    </template>
                </section>
            </div>
            <div class="tab-pane fade" v-if="accessRights.groupOfRisk" :class="{ 'active show': isActive('tab2') }" id="tab2">
                <section class="content">
                    <report-with-params-poll-filter
                            v-bind:filters="filterPoll"
                            v-on:apply="onFiltersApply($event)"
                            v-on:reset="onFiltersReset($event)"
                            v-on:exportReport="exportReportPoll($event)"
                    />
                    <template v-if="!isLoading">
                    <div class="table-inner mb-4" v-if="reportPoll">
                        <table class="table-custom">
                            <thead>
                            <tr>
                                <th v-for="(hdr, index) in reportPoll.header" :key="index">{{hdr.title}}
                                  <i style="cursor: pointer" @click="columnSort(index, 'tab2')"  class="ml-2 fas text-gray fa-sort-amount-down-alt" :class="{'fas text-black fa-sort-amount-up': sortMode && index === idx, 'text-black': index === idx}"></i></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(item, i) in reportPoll.data" :key="i">
                                <td v-for="(hdr, index) in reportPoll.header" :key="index">
                                    {{item.values[index]}}
                                </td>
                            </tr>
                            </tbody>
                            <tfoot>
                            <tr>
                                <td v-for="(val, i) in reportPoll.summary[0].values" :key="i">
                                    {{val}}
                                </td>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                    </template>
                    <template v-else>
                      <div>Загрузка...</div>
                    </template>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
import PageHeader from "@/common/components/page/PageHeader";
import Api from "../api/withParams";
import ReportWithParamsRasFilter from "./ReportWithParamsRasFilter";
import ReportWithParamsPollFilter from "./ReportWithParamsPollFilter";
import Constants from '@/common/constants'

export default {
  name: "ReportWithParams",
  components: {
    PageHeader,
    ReportWithParamsRasFilter,
    ReportWithParamsPollFilter
  },
  props: {
    accessRights: Object,
    nn: Number
  },
  data() {
    return {
      activeItem: '',

      filterRas: {},
      filterPoll: {},
      reportRas: null,
      reportPoll: null,

      sortMode: false,
      idx: null,
      idxCache: null,

      isLoading: false
    };
  },
  watch: {
    'nn': function() {
        this.load();
    },
  },
  methods: {
    isActive (menuItem) {
        return this.activeItem === menuItem
    },
    setActive (menuItem) {
        this.activeItem = menuItem
    },
    load() {
        if(!this.activeItem) {
            if (this.accessRights.patientRegistry) {
                this.activeItem = 'tab1';
            } else if (this.accessRights.groupOfRisk) {
                this.activeItem = 'tab2';
            }
        }
    },
    loadPage() {
      this.isLoading = true;
        switch (this.activeItem) {
          case 'tab1':
            Api.getReportRasWithParams(this.filterRas)
              .then((response) => {
                this.reportRas = response.data;
                this.isLoading = false;
              })
              .catch(() => {
                this.showError();
                this.isLoading = false;
              });
            break;
          case 'tab2': {
            Api.getReportPollWithParams(this.filterPoll)
              .then((response) => {
                this.reportPoll = response.data;
                this.isLoading = false;
              })
              .catch(() => {
                this.showError();
                this.isLoading = false;
              });
            break;
          }
        }
      },
      onFiltersApply(filters) {
        switch (this.activeItem) {
          case 'tab1':
            this.filterRas = filters;
            break;
          case 'tab2':
            this.filterPoll = filters;
            break;
        }
        this.loadPage();
      },
      onFiltersReset(filters) {
        switch (this.activeItem) {
          case 'tab1':
            this.filterRas = filters || {};
            break;
          case 'tab2':
            this.filterPoll = filters || {};
            break;
        }
        this.loadPage();
      },
      exportReportRas(filters) {
        Api.exportReportRasWithParams(filters);
      },
      exportReportPoll(filters) {
        Api.exportReportPollWithParams(filters);
      },
      showError() {
        Constants.alert.fire('Ошибка', 'При формировании отчета произошла ошибка. Обратитесь в техническую поддержу.', 'error');
      },
      columnSort(index, tab) {
        this.idx = index
        if(this.idxCache !== this.idx) {
          this.sortMode = false
        }
        this.idxCache = index
        let sortM = this.sortMode
        function Sort(x, y){
          if (x.values[index] < y.values[index]) {
            return sortM === true ? -1 : 1;
          }
          if (x.values[index] > y.values[index]) {
            return sortM === true ? 1 : -1;
          }
          return 0;
        }
        if(tab === "tab1") {
          this.reportRas.data.sort(Sort)
        }
        if(tab === 'tab2') {
          this.reportPoll.data.sort(Sort)
        }
        this.sortMode = !this.sortMode
      }
  },
  created() {
  },
  mounted() {
  }
};
</script>
<style lang="scss" scoped>
@import "/src/assets/theme/default/colors.scss";
    .nav-tabs {
        margin-top: 20px;
        justify-content: center;
        border: none;
        .nav-item {
            max-width: 200px;
            width: 100%;
            &:not(:last-child){
                margin-right: 16px;
            }
            .nav-link {
                padding: 7.5px 17.5px;
                text-align: center;
                font-family: "Source Sans Pro", sans-serif;
                font-style: normal;
                font-weight: 600;
                font-size: 14px;
                line-height: 120%;
                color: $gray-dark;
                border: 1px solid $gray-light1;
                box-sizing: border-box;
                border-radius: 6px;

                &.active {
                    color: $blue-light;
                    border: 1px solid $blue-light;
                }
            }
        }
    }

    .btn{
        border-radius: 12px;
        i{
            padding-right: 8px;
        }
    }
    .content{
        padding: 32px ;
        position: relative;
        overflow-y: visible;
        .filter{
            position: absolute;
            width: 350px;
            height: auto;
            top: 0;
            right: 0;
            overflow: hidden;
            background-color: transparent;
            opacity: 1;
            transition: opacity .2s;
        }

        .filter-enter, .filter-leave-to /* .fade-leave-active below version 2.1.8 */ {
            opacity: 0;
        }

        .table-custom tbody tr:last-child td:nth-child(1) {
            border-radius: 0;
        }
        .table-custom tbody tr:last-child td:last-child {
            border-radius: 0;
        }
        .table-custom .foot {
            font-weight: bold;
        }
    }      
</style>